import { initState, types } from "./types";

const teamsReducer = (state = initState, action) => {
  switch (action.type) {
    case types.GET_TEAMS_REQUEST:
      return { ...state, loading: true, error: null };

    case types.GET_TEAMS_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.list || [],
        counts: action.counts || {},
        error: null,
      };

    case types.GET_TEAMS_FAILED:
      return { ...state, loading: false, error: action.error };

    case types.CREATE_TEAM_REQUEST:
    case types.UPDATE_TEAM_REQUEST:
    case types.ARCHIVE_TEAM_REQUEST:
    case types.ASSIGN_USER_TEAM_REQUEST:
      return { ...state, saving: true, error: null };

    case types.CREATE_TEAM_SUCCESS: {
      const { team } = action;
      if (!team) return { ...state, saving: false };
      // Replace if already present (defensive), else append; resort by name.
      const next = [...state.list.filter((t) => t._id !== team._id), team].sort(
        (a, b) => (a.name || "").localeCompare(b.name || ""),
      );
      return { ...state, saving: false, list: next };
    }

    case types.UPDATE_TEAM_SUCCESS: {
      const { team, oldName } = action;
      if (!team) return { ...state, saving: false };
      const next = state.list
        .map((t) => (t._id === team._id ? team : t))
        .sort((a, b) => (a.name || "").localeCompare(b.name || ""));
      // Migrate counts key if rename happened.
      let nextCounts = state.counts;
      if (oldName && oldName !== team.name && state.counts[oldName] != null) {
        const { [oldName]: prevCount, ...rest } = state.counts;
        nextCounts = { ...rest, [team.name]: prevCount };
      }
      return { ...state, saving: false, list: next, counts: nextCounts };
    }

    case types.ARCHIVE_TEAM_SUCCESS: {
      const { id } = action;
      const archived = state.list.find((t) => t._id === id);
      const next = state.list.filter((t) => t._id !== id);
      let nextCounts = state.counts;
      if (archived?.name && nextCounts[archived.name] != null) {
        const { [archived.name]: _drop, ...rest } = nextCounts;
        nextCounts = rest;
      }
      return { ...state, saving: false, list: next, counts: nextCounts };
    }

    case types.ASSIGN_USER_TEAM_SUCCESS: {
      // Adjust counts optimistically. The user record itself is updated via
      // getCompanyUsers refresh dispatched alongside this success.
      const { previousTeam, team } = action;
      const counts = { ...state.counts };
      if (previousTeam && counts[previousTeam] > 0) {
        counts[previousTeam] -= 1;
        if (counts[previousTeam] <= 0) delete counts[previousTeam];
      }
      if (team) counts[team] = (counts[team] || 0) + 1;
      return { ...state, saving: false, counts };
    }

    case types.CREATE_TEAM_FAILED:
    case types.UPDATE_TEAM_FAILED:
    case types.ARCHIVE_TEAM_FAILED:
    case types.ASSIGN_USER_TEAM_FAILED:
      return { ...state, saving: false, error: action.error };

    default:
      return state;
  }
};

export default teamsReducer;
